import { useState, useMemo } from "react";

import { AuthContext } from "./AuthContext";
import { ProfileData } from "../../data/auth";
import { StorageKeys } from "../../enums";
import { useCookies } from "react-cookie";

export type AuthContextProviderProps = {
  children: React.ReactNode;
};

export const AuthContextProvider: React.FC<AuthContextProviderProps> = function ({ children }) {
  const [cookies, setCookie, removeCookie] = useCookies(["ACCESS_TOKEN", "REFERESH_TOKEN", "BUSINESS_ID"]);
  const [user, setUser] = useState<ProfileData | undefined>(() => {
    var data = localStorage.getItem(StorageKeys.USER_DATA);
    if (data === null) {
      return undefined;
    }
    return JSON.parse(data) as ProfileData;
  });

  const saveToken = function (accessToken: string, refreshToken?: string, userData?: ProfileData) {
    setCookie("ACCESS_TOKEN", accessToken, {
      path: "/",
    });

    if (refreshToken) {
      setCookie("REFERESH_TOKEN", refreshToken, {
        path: "/",
      });
    }

    if (userData) updateInfo(userData);
  };

  const updateInfo = function (userData: ProfileData) {
    const data = { ...userData, profileImage: userData.photoUrl || "/assets/images/avatar.png" };
    localStorage.setItem(StorageKeys.USER_DATA, JSON.stringify(data));
    setUser(userData);
  };

  const signOut = function () {
    removeCookie("ACCESS_TOKEN", { path: "/" });
    removeCookie("REFERESH_TOKEN", { path: "/" });
    removeCookie("BUSINESS_ID", { path: "/" });

    localStorage.removeItem(StorageKeys.USER_DATA);
    setUser(undefined);
  };

  const contextValue = useMemo(() => {
    return { user, saveToken, updateInfo, signOut, isAuthenticated: !!cookies.ACCESS_TOKEN };
  }, [user, cookies.ACCESS_TOKEN]);

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};
export default AuthContextProvider;
